<template>
  <div>
    <div v-if="list" class="container-fluid header-increased-padding">
       <div class="row">
        <div class="col-md-12">
          <div class="col-md-3">
            <div class="sender-details">
              <span class="block overflow-text header-text">
                <span>{{ this.$t('app.tasks.identifier') }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="sender-details">
              <span class="block overflow-text header-text">
                <span>{{ this.$t('app.tasks.reporter') + '/' + this.$t('app.tasks.assignee') }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="sender-details">
              <span class="block overflow-text header-text">
                <span>{{ this.$t('app.tasks.deadline') }}</span>
              </span>
            </div>
          </div>
          <div class="col-md-2">
            <div class="sender-details">
              <span class="block overflow-text header-text">
                <span>{{ this.$t('app.tasks.attributes.status') }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid increased-padding"
        v-for="(element,index) in list"
            :key="index"
            :class="selectedIndex === index || selectedTaskId == element.id ? 'selected' : ''"
            @click="itemSelected({element: element, index: index})">
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-3">
              <div class="sender-details">
                <td class="block overflow-text">
                  <span>{{ element.provided_identifier}}</span>
                </td>
              </div>
            </div>
            <div class="col-md-4">
              <div class="sender-details">
                <td class="block overflow-text">
                  <span>{{ taskUsers(element) }}</span>
                </td>
              </div>
            </div>
            <div class="col-md-3">
              <div class="sender-details">
                <td class="block overflow-text">
                  <span>{{ element.deadline | moment("YYYY-MM-DD HH:mm") }}</span>
                </td>
              </div>
            </div>
            <div class="col-md-2">
              <div class="sender-details">
                <td class="block overflow-text">
                  <span>{{ $t(`app.tasks.statuses.${element.status}`) }}</span>
                </td>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <div v-if="isLoading" class="empty-task-list mt-20">{{loadingText}}</div>
    <div v-else-if="!isLoading && list.length === 0" class="empty-task-list mt-20">{{$t('app.tasks.empty_list')}}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TasksInboxTable",
  components: {},
  props: {
    list: {
      type: Array,
      required: true
    },
    loadingText: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    selectedTaskId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      selectedIndex: undefined
    };
  },
  mounted() {
    this.setupScrollListener();
  },
  beforeDestroy() {
    this.removeScrollListener();
  },
  methods: {
    itemSelected(payload) {
      this.selectedIndex = payload.index
      this.$emit('itemSelected', payload.element)
    },
    taskUsers(task) {
      if(task.assignee_user && task.assignee_user.id === task.reporter_user.id) {
        return task.reporter_user.name
      } else if(task.assignee_user && task.assignee_user.id !== task.reporter_user.id) {
        return `${task.reporter_user.name}/${task.assignee_user.name}`
      } else {
        return `${task.reporter_user.name}/${this.$t('app.tasks.no_assignee')}`
      }
    },
    setupScrollListener() {
      // Find the scrollable container
      const container = document.querySelector('.content');
      if (container) {
        container.addEventListener('scroll', this.handleScroll);
      }
    },
    removeScrollListener() {
      const container = document.querySelector('.content');
      if (container) {
        container.removeEventListener('scroll', this.handleScroll);
      }
    },
    handleScroll(event) {
      const container = event.target;
      // Check if we've scrolled near the bottom
      if (container.scrollHeight - container.scrollTop <= container.clientHeight + 100) {
        if (!this.isLoading) {
          this.$emit('appendTasks');
        }
      }
    }
  },
  watch: {
    task(newValue, oldValue) {
      this.showDropDown = false;
    }
  }
};
</script>

<style lang="scss" scoped>

tr {
  border-bottom: solid 1px #f1f1f3;
  cursor: pointer;
}

td {
  white-space: normal !important;
  word-wrap: break-word;
}
.empty-task-list {
  font-size: 21px;
  text-align: center;
}
.date-field {
  padding-right: 15px;
}

.selected {
  background: #eee;
}

.header-text {
  color: #272B34;
  font-size: 12px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/TasksInboxTable.vue